var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-not-found" }, [
      _c("p", [_vm._v("404")]),
      _c("p", [_vm._v("Not Found!")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }